import React, { useCallback, useEffect, useState, lazy } from 'react';
import { useReveal } from '../lib/useReveal';
import { ChevronLeftIcon, ChevronRightIcon } from '../lib/icons';
const SLIDES = [{
  src: 'https://cdn.magicpatterns.com/uploads/fSYa3hTj9qSu8YdyuvMKkK/Captura_de_pantalla_2026-06-01_114524.png',
  label: 'Tomo 1',
  title: 'Bases de la Pastelería Desde Cero'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8vajvTaH2UffraU6Y1NTbX/Captura_de_pantalla_2026-06-01_114617.png',
  label: 'Tomo 3',
  title: 'Pastelería para Emprender Desde Casa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rgNHQW8keXeLBi6Gnjmhbj/Captura_de_pantalla_2026-06-01_114631.png',
  label: 'Tomo 4',
  title: 'Postres y Dulces Más Vendidos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iyUueEoRKiFfhT42s2k1ag/Captura_de_pantalla_2026-06-01_114645.png',
  label: 'Tomo 5',
  title: 'Decoración y Presentación Profesional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vdob28FMGtTY2KqVL8VDve/Captura_de_pantalla_2026-06-01_114601.png',
  label: 'Página 10',
  title: 'Cómo Armar una Torta Profesional'
}];
export function CarouselSection() {
  const [ref, isVisible] = useReveal();
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const next = useCallback(() => setIndex(i => (i + 1) % SLIDES.length), []);
  const prev = useCallback(() => setIndex(i => (i - 1 + SLIDES.length) % SLIDES.length), []);
  // Autoplay
  useEffect(() => {
    if (paused) return;
    const t = setInterval(next, 4000);
    return () => clearInterval(t);
  }, [paused, next]);
  const current = SLIDES[index];
  return <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-[#fce7e9]/40 to-[#fff8f9] overflow-hidden" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <div className="text-center mb-8" data-id="element-43">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-44">
            ♡ Mirá por dentro ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-45">
            Un vistazo a{' '}
            <span className="italic text-[#e89aaa]" data-id="element-46">tu MegaPack.</span>
          </h2>
          <p className="text-sm md:text-base text-[#8b6f47] mt-3 max-w-md mx-auto" data-id="element-47">
            Cada tomo es una experiencia visual pensada para inspirarte y
            guiarte paso a paso.
          </p>
        </div>

        <div ref={ref} className={`reveal relative ${isVisible ? 'is-visible' : ''}`} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} data-id="element-48">
          {/* Slides */}
          <div className="relative h-[480px] sm:h-[560px] md:h-[640px] flex items-center justify-center" data-id="element-49">
            {SLIDES.map((slide, i) => {
            const offset = i - index;
            const total = SLIDES.length;
            // Normalize offset to handle wrap-around (so going from last to first is short)
            let normalized = offset;
            if (normalized > total / 2) normalized -= total;
            if (normalized < -total / 2) normalized += total;
            const isActive = normalized === 0;
            const isAdjacent = Math.abs(normalized) === 1;
            const isVisibleSlide = Math.abs(normalized) <= 1;
            return <div key={i} className="absolute top-1/2 left-1/2 transition-all duration-700 ease-out" style={{
              transform: `translate(-50%, -50%) translateX(${normalized * 60}%) scale(${isActive ? 1 : 0.8})`,
              opacity: isActive ? 1 : isAdjacent ? 0.4 : 0,
              zIndex: isActive ? 10 : isAdjacent ? 5 : 0,
              pointerEvents: isVisibleSlide ? 'auto' : 'none',
              filter: isActive ? 'none' : 'blur(2px)'
            }} data-id="element-50">
                  <div className="relative w-[260px] sm:w-[320px] md:w-[400px] rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(232,154,170,0.25)] border-[6px] border-white bg-white" data-id="element-51">
                    <img src={slide.src} alt={`${slide.label} — ${slide.title}`} className="w-full h-auto block" loading="lazy" data-id="element-52" />
                  </div>
                </div>;
          })}
          </div>

          {/* Caption */}
          <div className="text-center mt-6 min-h-[60px]" data-id="element-53">
            <span className="inline-block bg-[#e89aaa] text-white text-[10px] font-bold tracking-[0.25em] uppercase px-3 py-1 rounded-full mb-2" data-id="element-54">
              {current.label}
            </span>
            <p className="font-serif italic text-lg md:text-xl text-[#6b4f3a]" data-id="element-55">
              {current.title}
            </p>
          </div>

          {/* Arrows */}
          <button onClick={prev} aria-label="Anterior" className="absolute left-2 md:left-6 top-1/2 -translate-y-[80%] z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white border border-[#f4b6c2]/40 shadow-lg flex items-center justify-center text-[#e89aaa] hover:bg-[#fdf2f4] hover:scale-110 transition-all" data-id="element-56">
            <ChevronLeftIcon size={20} data-id="element-57" />
          </button>
          <button onClick={next} aria-label="Siguiente" className="absolute right-2 md:right-6 top-1/2 -translate-y-[80%] z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white border border-[#f4b6c2]/40 shadow-lg flex items-center justify-center text-[#e89aaa] hover:bg-[#fdf2f4] hover:scale-110 transition-all" data-id="element-58">
            <ChevronRightIcon size={20} data-id="element-59" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-60">
          {SLIDES.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`transition-all duration-300 rounded-full ${i === index ? 'w-8 h-2 bg-[#e89aaa]' : 'w-2 h-2 bg-[#f4b6c2]/60 hover:bg-[#f4b6c2]'}`} data-id="element-61" />)}
        </div>
      </div>
    </section>;
}